module.exports = __webpack_public_path__ + "img/28.83859d57.jpg";